import { getContractBasedDataSelector } from '@cp-shared-15/frontend-integration';
import { RootState } from '../../store/rootReducer';

export const EarlySettlementDataSelector = getContractBasedDataSelector((state: RootState) => state.earlySettlement);
